export default class ModalMenu {
    constructor($el) {
        this.$el = $el;
        this.$btn = this.$el.querySelector('[data-modal-trigger]');
        this.$modal = this.$el.querySelector('[data-modal]');
        this.$modalContainer = this.$el.querySelector('[data-modal-container]');
        this.$mouseOver = false;
        this.$collapsableItem = this.$el.querySelector('[data-collapsable-item]');
        this.isXXL = true;
        this.mediaQuery = window.matchMedia('(max-width: 1400px)');

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleCollapsable = this.toggleCollapsable.bind(this);
        this.checkWidth = this.checkWidth.bind(this);
        this.debounce = this.debounce.bind(this);

        this.debouncedCheck = this.debounce(() => {
            this.checkWidth();
        }, 250);

        this.checkWidth();

        window.addEventListener('resize', this.debouncedCheck);
    }

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    checkWidth() {
        this.isXXL = !this.mediaQuery.matches;

        this.$el.removeEventListener('click', this.toggleCollapsable);
        this.$el.removeEventListener('mouseover', this.showModal);

        if (!this.isXXL) {
            this.$el.addEventListener('click', this.toggleCollapsable);
            return;
        }

        if (!this.$modal || !this.$modalContainer) return;

        this.$el.addEventListener('mouseover', this.showModal);

        this.$modal.addEventListener('mouseover', () => {
            this.$mouseOver = true;
        });

        this.$modalContainer.addEventListener('mouseleave', () => {
            this.$mouseOver = false;
            this.closeModal();
        });

        this.$el.addEventListener('mouseleave', () => {
            setTimeout(this.closeModal, 300);
        });
    }

    showModal(e) {
        e.preventDefault();
        if( ! this.$modalContainer) {
            return;
        }
        this.$modalContainer.classList.add('modal__container--open');
        this.$modal.classList.add('modal--open');
    }

    closeModal() {
        if( ! this.$mouseOver) {
            this.$modalContainer.classList.remove('modal__container--open');
            this.$modal.classList.remove('modal--open');
        }
    }

    toggleModal(e) {
        if( ! this.$modalContainer.classList.contains('modal__container--open')) {
            this.$modalContainer.classList.add('modal__container--open');
            this.$modal.classList.add('modal__container--open');
            return;
        }
        this.$modalContainer.classList.remove('modal__container--open');
        this.$modal.classList.remove('modal__container--open');
    }

    toggleCollapsable(e) {
        e.preventDefault();
        if( ! this.$collapsableItem) {
            window.location.href = e.target.href;
        }
        this.$collapsableItem.classList.toggle('collapsable__item__text--open')
    }
}